import { CategorySearchResultPayload } from '@/redux/modules/search/search.types';
import { PayloadlessAction, TypedActionWithPayloadMetaActionTime } from '@/types/redux';

export const LOAD_CATEGORY_RESULTS_FAIL = 'LOAD_CATEGORY_RESULTS_FAIL';
export type LOAD_CATEGORY_RESULTS_FAIL_ACTION = PayloadlessAction<typeof LOAD_CATEGORY_RESULTS_FAIL>;

// Distinct from LOAD_CATEGORY_RESULTS_FAIL: dispatched when search-party rejects a
// deep category page with 403 (auth required), so the reducer can show the sign-in
// interstitial instead of the generic SearchError technical-difficulties UI.
export const LOAD_CATEGORY_RESULTS_AUTH_REQUIRED = 'LOAD_CATEGORY_RESULTS_AUTH_REQUIRED';
export type LOAD_CATEGORY_RESULTS_AUTH_REQUIRED_ACTION = PayloadlessAction<typeof LOAD_CATEGORY_RESULTS_AUTH_REQUIRED>;

export const LOAD_CATEGORY_RESULTS_REQUEST = 'LOAD_CATEGORY_RESULTS_REQUEST';
export type LOAD_CATEGORY_RESULTS_REQUEST_ACTION = PayloadlessAction<typeof LOAD_CATEGORY_RESULTS_REQUEST>;

export const LOAD_CATEGORY_RESULTS_SUCCESS = 'LOAD_CATEGORY_RESULTS_SUCCESS';
export type LOAD_CATEGORY_RESULTS_SUCCESS_ACTION = TypedActionWithPayloadMetaActionTime<
    typeof LOAD_CATEGORY_RESULTS_SUCCESS,
    CategorySearchResultPayload
>;
